module.exports = __webpack_public_path__ + "img/member-icon2-01.866224ad.png";